export default __webpack_public_path__ + "static/media/left-arrow.04464470.svg";